import { envUtils } from '@/lib/utils';

export const KIZEO_MESSAGE_TYPES = {
  KHUB_REQUEST_VALIDATION: 'KHUB_REQUEST_VALIDATION',
  KIZEO_EMBED_INIT: 'KIZEO_EMBED_INIT',
  KHUB_READY: 'KHUB_READY',
  KHUB_OPEN_BUSINESS_MODAL: 'KHUB_OPEN_BUSINESS_MODAL',
} as const;

const sendMessageToKizeo = (type: keyof typeof KIZEO_MESSAGE_TYPES) => {
  const kizeoOrigin = envUtils.getKizeoFormsUrl();
  if (kizeoOrigin) {
    window.parent.postMessage({ type }, kizeoOrigin);
  }
};

export const kizeoMessaging = {
  sendKhubReadyMessage: () => sendMessageToKizeo(KIZEO_MESSAGE_TYPES.KHUB_READY),
  sendKhubRequestValidation: () => sendMessageToKizeo(KIZEO_MESSAGE_TYPES.KHUB_REQUEST_VALIDATION),
  sendOpenBusinessModalMessage: () =>
    sendMessageToKizeo(KIZEO_MESSAGE_TYPES.KHUB_OPEN_BUSINESS_MODAL),
};